import { viewerZoomAnimationMs } from 'features/knowledgeDocumentViewer/components/viewer/shared/preferInstantViewerMotion'
import type { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch'

export function applyCenteredScale(
  transform: ReactZoomPanPinchRef | null,
  calculateNewScale: (currentScale: number) => number,
  animationTime = viewerZoomAnimationMs()
) {
  if (!transform) return

  const wrapper = transform.instance.wrapperComponent
  if (!wrapper) return

  const wrapRect = wrapper.getBoundingClientRect()
  const currentState = transform.instance.transformState
  const newScale = calculateNewScale(currentState.scale)
  const centerX = wrapRect.width / 2
  const centerY = wrapRect.height / 2
  const scaleDiff = newScale / currentState.scale

  transform.setTransform(
    centerX - (centerX - currentState.positionX) * scaleDiff,
    centerY - (centerY - currentState.positionY) * scaleDiff,
    newScale,
    animationTime
  )
}
